import { render, staticRenderFns } from "./VecdynDetail.vue?vue&type=template&id=71d3b45f&"
import script from "./VecdynDetail.vue?vue&type=script&lang=js&"
export * from "./VecdynDetail.vue?vue&type=script&lang=js&"
import style0 from "./VecdynDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports